import React from 'react';
import type { components } from '../../../../types/learnerApi';

type Config = components['schemas']['SanitizedNumericConfig'];

export interface NumericAnswer {
  value: number;
}

export interface NumericInputViewProps {
  item: { id: string; points?: number; config: Config };
  mode: 'learner' | 'preview';
  value?: NumericAnswer;
  onChange?: (value: NumericAnswer) => void;
  disabled?: boolean;
}

const NumericInputView: React.FC<NumericInputViewProps> = ({
  item,
  mode,
  value,
  onChange,
  disabled,
}) => {
  return (
    <div className="space-y-3">
      <p className="font-medium text-text-primary">{item.config.question}</p>
      <input
        type="number"
        value={value?.value ?? ''}
        onChange={(e) => {
          if (disabled || mode === 'preview') return;
          const num = parseFloat(e.target.value);
          if (!isNaN(num)) onChange?.({ value: num });
        }}
        disabled={disabled}
        placeholder="Enter a number…"
        className="w-full max-w-xs px-3 py-2 rounded-lg border border-border-primary dark:border-white/15 bg-white dark:bg-white/[0.04] text-text-primary placeholder:text-text-tertiary text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 disabled:opacity-60"
      />
      {item.points != null && (
        <p className="text-xs text-text-tertiary">{item.points} pt{item.points !== 1 ? 's' : ''}</p>
      )}
    </div>
  );
};

export default NumericInputView;
